import type { FlavorConfig } from '../types';

/**
 * Flavor A Configuration
 * Classic design with standard layout
 * Used as the default flavor
 */
export const flavorAConfig: FlavorConfig = {
  id: 'A',
  name: 'Flavor A - Classic',
  className: 'flavor-a',
  description: 'Classic design with standard layout and light backgrounds',
  styles: {
    borderRadius: '16px',
    cardBackground: '#eff1f5',
    popupBackground: '#fff',
    iconBackground: '#f7f7f7',
  },
};

export default flavorAConfig;
